interface SelectableCamp {
  id: string
  date?: string | null
  endDate?: string | null
}

/**
 * Camps an admin can move a registration to. A camp that is over is hidden unless past
 * camps are asked for, so last season's camps cannot be picked by accident. Camps the
 * registration already points at stay in the list, otherwise a select would show the wrong
 * value for them.
 */
export function filterSelectableCamps<T extends SelectableCamp>(
  camps: T[],
  options: { showPast: boolean; keepIds?: Array<string | null | undefined>; now?: Date },
): T[] {
  if (options.showPast) return camps

  const startOfToday = new Date(options.now ?? new Date())
  startOfToday.setHours(0, 0, 0, 0)
  const keep = new Set(options.keepIds?.filter(Boolean))

  return camps.filter((camp) => {
    if (keep.has(camp.id)) return true
    const end = camp.endDate ?? camp.date
    // A camp without any date cannot be placed in time, so it stays selectable
    return !end || new Date(end) >= startOfToday
  })
}
